//require('dotenv').config();

import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";

import "../index.css";
import '../output.css';

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

import "./waitlist.css"; // <-- add this

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:5050";

function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < breakpoint);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, [breakpoint]);

  return isMobile;
}


function useScrollMarquee(trackRef, { speed = 0.35, damping = 0.92 } = {}) {
  const stateRef = useRef({
    x: 0,
    v: 0,
    lastY: 0,
    lastT: 0,
    raf: 0,
    spanW: 1, // width of one repeated chunk
  });

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    // Respect reduced motion
    const mq = window.matchMedia?.("(prefers-reduced-motion: reduce)");
    if (mq?.matches) return;

    const s = stateRef.current;

    // Measure width of one "chunk" (first child span).
    const measure = () => {
      const first = track.children?.[0];
      s.spanW = Math.max(1, first ? first.getBoundingClientRect().width : track.scrollWidth / 3 || 1);
    };

    const clampMod = (x, m) => {
      // keep x in [-m, 0) to avoid huge numbers
      const r = x % m;
      return r > 0 ? r - m : r;
    };

    const onScroll = () => {
      const y = window.scrollY || window.pageYOffset || 0;
      const t = performance.now();
      if (!s.lastT) {
        s.lastT = t;
        s.lastY = y;
        return;
      }
      const dy = y - s.lastY;
      const dt = Math.max(16, t - s.lastT);

      // dy>0 (scroll down) -> move left (negative)
      // convert to velocity; tweak `speed` to taste
      s.v += (-dy / dt) * 1000 * speed;

      s.lastY = y;
      s.lastT = t;
    };

    const tick = () => {
      // integrate
      s.x += s.v * (1 / 60);

      // wrap seamlessly by one chunk width
      s.x = clampMod(s.x, s.spanW);

      // apply
      track.style.transform = `translate3d(${s.x}px, 0, 0)`;

      // friction
      s.v *= damping;

      // stop when basically still (saves CPU)
      if (Math.abs(s.v) < 0.01) {
        s.v = 0;
        s.raf = 0;
        return;
      }

      s.raf = requestAnimationFrame(tick);
    };

    const kick = () => {
      if (!s.raf) s.raf = requestAnimationFrame(tick);
    };

    const onScrollKick = () => {
      onScroll();
      kick();
    };

    measure();
    window.addEventListener("scroll", onScrollKick, { passive: true });
    window.addEventListener("resize", measure);

    // also react to touchpad wheel (helps on pages that don’t scroll much)
    const onWheel = (e) => {
      // wheel deltaY behaves like dy
      const dy = e.deltaY || 0;
      s.v += (-dy / 16) * speed * 10;
      kick();
    };
    window.addEventListener("wheel", onWheel, { passive: true });

    return () => {
      window.removeEventListener("scroll", onScrollKick);
      window.removeEventListener("resize", measure);
      window.removeEventListener("wheel", onWheel);
      if (s.raf) cancelAnimationFrame(s.raf);
    };
  }, [trackRef, speed, damping]);
}

export default function Waitlist() {
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [combo, setCombo] = useState("emailOnly"); // default so the UI shows immediately
  const [status, setStatus] = useState(null);
  const [refID, setRefID] = useState("");
  const [refBy, setRefBy] = useState("");
  const [shareLink, setShareLink] = useState("");

  const [open, setOpen] = useState(false); // NEW

  const isMobile = useIsMobile();

  const trackRef = useRef(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (ref) setRefBy(ref.trim().toUpperCase());
  }, []);

  // NEW: lock scroll + escape to close modal
  useEffect(() => {
    if (!open) return;

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const onKeyDown = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [open]);

  useScrollMarquee(trackRef, {
    speed: 0.2,
    damping: 0.6,
  });

  const postMongo = async (e) => {
    e.preventDefault();
    setStatus("loading");

    try {
      const res = await fetch(`${API_BASE}/api/waitlist`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: email || undefined,
          phone: phone || undefined,
          combo,
          refID: refBy || undefined,
        }),
      });

      const data = await res.json();

      if (data.refID) {
        setRefID(data.refID);
        setShareLink(`${window.location.origin}/home?ref=${data.refID}`);
      }

      if (!res.ok) {
        throw new Error(data.error || "Something went wrong");
      }

      if (data.position) {
        setStatus(`${data.message} You’re #${data.position} in line.`);
      } else {
        setStatus(data.message || "Success!");
      }

      setEmail("");
      // keep phone as-is or clear it; your call:
      // setPhone("");
    } catch (err) {
      setStatus(err.message);
    }
  };

  const showEmail = combo === "emailOnly" || combo === "combined";
  const showPhone = combo === "phoneOnly" || combo === "combined";
  const isLoading = status === "loading";

  return (
    <section className="wl">
      {/* subtle background */}
      <div className="wl__bg" aria-hidden="true" />

      <div className="wl__inner">
        <div className="wl__grid">
          {/* LEFT: copy */}

          {/* RIGHT: (removed) */}
          <div aria-hidden="true" />
        </div>

        <div className="wl__joinWrap">

        {/* TOP STRIP */}
<div className="wl__ribbonTop" aria-hidden="true">
<div className="wl__ribbonTopCol wl__ribbonTopCol--label">
{/*  <span className="wl__ribbonTopLabel">NEXT</span>*/}
</div>

<div className="wl__ribbonTopCol wl__ribbonTopCol--marquee">
  <div className="wl__marquee">
    <div className="wl__marqueeTrack" ref={trackRef}>
      <span>↓ JOIN THE FINANCIAL REVOLUTION ↓ JOIN THE FINANCIAL REVOLUTION ↓ JOIN THE FINANCIAL REVOLUTION ↓ JOIN THE FINANCIAL REVOLUTION ↓ JOIN THE FINANCIAL REVOLUTION ↓ JOIN THE FINANCIAL REVOLUTION ↓ JOIN THE FINANCIAL REVOLUTION ↓ JOIN THE FINANCIAL REVOLUTION ↓ JOIN THE FINANCIAL REVOLUTION ↓ JOIN THE FINANCIAL REVOLUTION ↓ JOIN THE FINANCIAL REVOLUTION ↓ JOIN THE FINANCIAL REVOLUTION</span>
      {/* <span>↓ JOIN THE FINANCIAL REVOLUTION ↓ JOIN THE FINANCIAL REVOLUTION ↓ JOIN THE FINANCIAL REVOLUTION ↓ JOIN THE FINANCIAL REVOLUTION ↓ JOIN THE FINANCIAL REVOLUTION ↓ JOIN THE FINANCIAL REVOLUTION</span>
      <span>↓ JOIN THE FINANCIAL REVOLUTION ↓ JOIN THE FINANCIAL REVOLUTION ↓ JOIN THE FINANCIAL REVOLUTION ↓ JOIN THE FINANCIAL REVOLUTION ↓ JOIN THE FINANCIAL REVOLUTION ↓ JOIN THE FINANCIAL REVOLUTION</span>*/}
    </div>
  </div>
</div>

<div className="wl__ribbonTopCol wl__ribbonTopCol--label">
  {/*  <span className="wl__ribbonTopLabel">ACTION</span>*/}
</div>
</div>


  <div className="wl__ribbonMain" style={{flexDirection: "row"}}>
      <Link to="/manifesto" className="wl__ribbonBtn wl__ribbonBtn--left">
        <span className="wl__ribbonLabel">
          Read more
        </span>
      </Link>
          <button className="wl__ribbonBtn wl__ribbonBtn--right" onClick={() => setOpen(true)}>
          <span className="wl__ribbonLabel">
            Join waitlist
            </span>
          </button>
          </div>
        </div>



      </div>

      {/* NEW: Modal popup */}
      {open && (
        <div
          className="wl__modalOverlay"
          role="dialog"
          aria-modal="true"
          aria-label="Join the waitlist"
          onMouseDown={(e) => {
            if (e.target === e.currentTarget) setOpen(false);
          }}
        >
          <div className="wl__modal">
            <button
              type="button"
              className="wl__modalClose"
              aria-label="Close"
              onClick={() => setOpen(false)}
            >
              ✕
            </button>

            {/* POPUP CONTENT: EXACTLY YOUR PANEL, UNCHANGED */}
            <div className="wl__panel">
              <div className="wl__panelTop">
                <div className="wl__panelTitle">Join the waitlist</div>
                {refBy ? (
                  <div className="wl__ref">
                    Referred by <span className="wl__refCode">{refBy}</span>
                  </div>
                ) : (
                  <div className="wl__ref wl__refMuted">
                    Have a referral link? It’ll apply automatically.
                  </div>
                )}
              </div>

              <form className="wl__form" onSubmit={postMongo}>
                {/* segmented control */}
                <div className="wl__seg" role="tablist" aria-label="Contact method">
                  {[
                    { key: "emailOnly", label: "Email" },
                    { key: "phoneOnly", label: "Phone" },
                    { key: "combined", label: "Both" },
                  ].map((opt) => (
                    <button
                      key={opt.key}
                      type="button"
                      className={`wl__segBtn ${combo === opt.key ? "isActive" : ""}`}
                      onClick={() => setCombo(opt.key)}
                    >
                      {opt.label}
                    </button>
                  ))}
                </div>

                {/* inputs */}
                <div className="wl__fields">
                  {showEmail && (
                    <div className="wl__field">
                      <label className="wl__label" htmlFor="wl-email">
                        Email
                      </label>
                      <input
                        id="wl-email"
                        type="email"
                        placeholder="you@domain.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="wl__input"
                        autoComplete="email"
                      />
                    </div>
                  )}

                  {showPhone && (
                    <div className="wl__field">
                      <label className="wl__label">Phone</label>
                      <div className="wl__phoneWrap">
                        <div className="wl__phoneShell">
                          <PhoneInput
                            country={"us"}
                            preferredCountries={["us"]}
                            value={phone}
                            onChange={setPhone}
                            inputClass="wl__phoneInput"
                            buttonClass="wl__phoneButton"
                            containerClass="wl__phoneContainer"
                            dropdownClass="wl__phoneDropdown"
                            placeholder="(555) 555-5555"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* CTA */}
                <button
                  type="submit"
                  className="wl__cta"
                  disabled={isLoading || (!showEmail && !showPhone)}
                >
                  {isLoading ? "Submitting…" : "Join waitlist"}
                </button>

                {/* status */}
                {status && (
                  <div className={`wl__status ${isLoading ? "isLoading" : ""}`}>
                    {isLoading ? "Submitting…" : status}
                  </div>
                )}

                {/* referral share */}
                {shareLink && (
                  <div className="wl__share">
                    <div className="wl__shareTop">
                      <div className="wl__shareTitle">You’re in.</div>
                      <div className="wl__shareSub">
                        Share your link to move up the line.
                      </div>
                    </div>

                    <div className={`wl__shareRow ${isMobile ? "isMobile" : ""}`}>
                      <input className="wl__shareInput" value={shareLink} readOnly />
                      <button
                        type="button"
                        className="wl__copyBtn"
                        onClick={async () => {
                          try {
                            await navigator.clipboard.writeText(shareLink);
                            setStatus("Copied referral link ✅");
                          } catch (err) {
                            // fallback
                            try {
                              const ta = document.createElement("textarea");
                              ta.value = shareLink;
                              ta.style.position = "fixed";
                              ta.style.left = "-9999px";
                              document.body.appendChild(ta);
                              ta.focus();
                              ta.select();
                              const ok = document.execCommand("copy");
                              document.body.removeChild(ta);
                              setStatus(
                                ok
                                  ? "Copied referral link ✅"
                                  : "Copy failed. select & copy manually."
                              );
                            } catch {
                              setStatus("Copy failed. select & copy manually.");
                            }
                          }
                        }}
                      >
                        Copy
                      </button>
                    </div>

                    {refID && (
                      <div className="wl__shareFoot">
                        Your code: <b>{refID}</b>
                      </div>
                    )}
                  </div>
                )}
              </form>

              <div className="wl__privacy">
                We only use this to notify you about launch & invites. We don't
                sell your info.
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
